// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fotter[data-v-0b004d88]{width:100%;height:3.125vw;background:#30313f;display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;font-size:.729167vw;font-family:PingFang-SC-Regular,PingFang-SC;font-weight:400;color:#fff;margin-top:5.46875vw;position:absolute;bottom:0;left:0}.position[data-v-0b004d88]{position:fixed;left:0;bottom:0}", ""]);
// Exports
module.exports = exports;
